import React from "react";
import { motion } from "framer-motion";

export default function WhoWeAreSection() {
  const points = [
    {
      icon: "🚀",
      title: "We build our own products",
      text: "We don't just take orders—we build and ship our own software, like our website & database monitoring platform. That product mindset goes into everything we make.",
    },
    {
      icon: "🤝",
      title: "We build for businesses too",
      text: "From a first idea to a launched product, we design, develop, and deliver custom web, mobile, AI, and cloud software for startups and growing companies.",
    },
    {
      icon: "🎯",
      title: "Your goals come first",
      text: "We take time to understand your vision and build around what matters most to your business—not a one-size-fits-all template.",
    },
    {
      icon: "💬",
      title: "You stay in the loop",
      text: "Regular updates, working demos, clear timelines, and no confusing jargon—so you always feel in control of your project.",
    },
    {
      icon: "🤲",
      title: "Honest & here for the long run",
      text: "Happy to sign an NDA, and we stay with you well after launch to support and grow what we've built together.",
    },
  ];

  return (
    <section className="who-we-are" id="who-we-are">
      <div className="who-container">
        <motion.div
          className="who-intro"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="who-badge">
            <span>✦</span>
            <span>Who We Are</span>
          </div>
          <h2>A product-minded software team</h2>
          <p className="who-lead">
            EmberByte Digital Solutions LLP is a software company in India. We build our
            own products <strong>and</strong> custom software for businesses—bringing the
            same care to both. One small, focused team that genuinely builds.
          </p>
        </motion.div>

        <div className="who-points">
          {points.map((p, i) => (
            <motion.div
              key={i}
              className="who-point"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.5 }}
              whileHover={{ y: -6 }}
            >
              <div className="who-point-icon">{p.icon}</div>
              <div className="who-point-body">
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
